import React from "react";

export default function CalenderPreferences() {
  return (
    <div className="account-preference col-md-6">
      <h4>Push Notification</h4>
      <div className="form-group">
        <h5>Notification interval</h5>
        <label>Receive notification in every</label>
        <select className="form-control">
          <option value="1">30 mins</option>
          <option value="1">In Active</option>
        </select>
      </div>
      <div className="allow-notification">
        <h5>Allow notification</h5>
        <div className="slide-input">
          <label className="switch">
            <input type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>
      </div>
      <h5>Notify When</h5>
      <div className="new-task">
        <div className="allow-notification">
          <h5>New task is assigned</h5>
          <div className="slide-input">
            <label className="switch">
              <input type="checkbox" checked />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        <div className="allow-notification">
          <h5>Client has added a new milestone</h5>
          <div className="slide-input">
            <label className="switch">
              <input type="checkbox" checked />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        <div className="allow-notification">
          <h5>Task is due today</h5>
          <div className="slide-input">
            <label className="switch">
              <input type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
      </div>
      <div className="form-group">
        <h5>Reminder</h5>
        <label>Send reminders</label>
        <select className="form-control">
          <option value="1">A day before</option>
          <option value="1">In Active</option>
        </select>
      </div>
    </div>
  );
}
